import React from 'react';
import PropTypes from 'prop-types';
import {
    hasValue,
    isScriptEmbedded,
    embedScript,
} from '../../../general/js/general-helpers';
import {
    initialiseEventCentreInstance,
    setClipTagContainerId,
    formatEventCentreParameters,
} from './imga-iframe-helpers';

import {
    getIMGArenaESModuleScriptInnerHTML,
    shouldLoadRouteToHoleClipTag,
} from '../../shot-tracker/js/shot-tracker-helpers';

class IMGAiFrameHolder extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            shotViewElement: null,
        };

        this.clipTagContainerDiv = React.createRef();

        this.loadRouteToHoleClipTag = this.loadRouteToHoleClipTag.bind(this);
        this.updateProps = this.updateProps.bind(this);

        window.frontRowSeatESModuleCallback = this.loadRouteToHoleClipTag;
    }

    componentDidMount() {
        this.updateProps();
        this.initHolderDivId();
        this.loadShotViewScripts();
    }

    updateProps() {
        const { eventCentreParameters } = this.props;

        if (
            eventCentreParameters !== undefined &&
            eventCentreParameters !== null
        ) {
            eventCentreParameters.targetElementSelector =
                eventCentreParameters.targetElement;
        }
    }

    initHolderDivId() {
        const { eventCentreParameters } = this.props;
        if (hasValue(eventCentreParameters)) {
            setClipTagContainerId(this.props, this.clipTagContainerDiv.current);
        }
    }

    loadRouteToHoleClipTag() {
        const clipTag = window.frontRowSeat;
        const routeHolder = this.clipTagContainerDiv.current;
        const { eventCentreParameters } = this.props;

        if (shouldLoadRouteToHoleClipTag(routeHolder, clipTag)) {
            const formattedEventCenterParams = formatEventCentreParameters(
                eventCentreParameters
            );

            this.setState(
                initialiseEventCentreInstance(
                    clipTag,
                    formattedEventCenterParams,
                    routeHolder
                )
            );
        }
    }

    loadShotViewScripts() {
        const { shotViewScripts } = this.props;

        if (!hasValue(shotViewScripts)) {
            return;
        }

        shotViewScripts.forEach((script) => {
            const { scriptSourceUrl, scriptType } = script;
            let innerHTML = '';

            if (scriptType === 'module') {
                innerHTML = getIMGArenaESModuleScriptInnerHTML(scriptSourceUrl);
            }

            if (!isScriptEmbedded(scriptSourceUrl, innerHTML)) {
                const { loadScriptAsync, useNoModule } = script;

                embedScript(
                    scriptSourceUrl,
                    loadScriptAsync,
                    this.loadRouteToHoleClipTag,
                    useNoModule,
                    scriptType,
                    innerHTML
                );
            }
        });
    }

    render() {
        return (
            <div
                ref={this.clipTagContainerDiv}
            ></div>
        );
    }
}

IMGAiFrameHolder.propTypes = {
    eventCentreParameters: PropTypes.object,
    shotViewScripts: PropTypes.array,
};

export default IMGAiFrameHolder;
